import FetchClient from "./FetchClient";

export const supportsDiscordImport = (retailer: string) => ["walmart", "home_depot", "target"].includes(retailer);
export interface DiscordImportRequest { retailer: string; category: string; channelId: string }
export interface DiscordImportProduct { messageId: string; code: string; title: string; price: number; postedAt: number }
export interface DiscordImportPreview { products: DiscordImportProduct[]; scanned: number; truncated: boolean }
export const previewDiscordImport = (request: DiscordImportRequest) =>
  FetchClient.post<DiscordImportPreview>("/admin/leads/import-discord/preview", request, {});
export const importDiscordProduct = (request: DiscordImportRequest, messageId: string) =>
  FetchClient.post<{ status: "imported" | "updated" }>("/admin/leads/import-discord/item", { ...request, messageId }, {});
